

import { NgModule } from '@angular/core';
import { TemplateInstanceModule } from 'tnx-admin-service/templateinstance';
import { TnxSharedModule } from 'tnx-shared';
import { BookmarkFormComponent } from './bookmark-form/bookmark-form.component';
import { BookmarkComponent } from './bookmark.component';
import { BookmarkRoutes } from './bookmark.routing';

export function declaration() {
    return [BookmarkComponent, BookmarkFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule,
        TemplateInstanceModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class BookmarkModule {
}

@NgModule({
    imports: [BookmarkModule, BookmarkRoutes],
    exports: [BookmarkModule]
})
export class BookmarkWithRouteModule {
}
